export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8663.880f9552.jpg";